interface DocumentViewerProps {
  fileUrl?: string;
  /** Altura mínima do `<embed>` — Gerencial (aba) usa o default. */
  minHeight?: string;
  /** Preenche o pai (modal da ficha): sem min-height que estoura o diálogo. */
  fill?: boolean;
}

export const DocumentViewer = ({
  fileUrl,
  minHeight = "60vh",
  fill = false,
}: DocumentViewerProps) => {
  if (!fileUrl) {
    return null;
  }

  return (
    <div
      className={
        fill
          ? "h-full min-h-0 w-full"
          : "flex h-full min-h-0 w-full flex-1"
      }
    >
      <embed
        src={fileUrl}
        type="application/pdf"
        className="h-full w-full"
        title="document-viewer"
        style={
          fill
            ? { height: "100%", width: "100%", minHeight: 0 }
            : { minHeight, height: minHeight }
        }
      />
    </div>
  );
};
